import { ChangeDetectorRef, Component, Input, ViewChild } from "@angular/core";
import {
  GraphicsInfoMediaField,
  GraphicsInfoMediaType,
} from "../../../../domain/graphics-info";
import { GraphicsMediaItemComponent } from "./media-item.component";

@Component({
  selector: "icn-graphics-media",
  templateUrl: "./media.component.html",
  styleUrls: ["./media.component.scss"],
})
export class GraphicsMediaComponent {
  constructor(private _changeDetectorRef: ChangeDetectorRef) {}

  editedMedia: GraphicsInfoMediaField;

  @Input() mediaFields: GraphicsInfoMediaField[];

  insertDynamicField(dynamicField: string) {
    this.editedMedia.dynamic = dynamicField;
  }

  onDynamicClick(_event: unknown, _media: GraphicsInfoMediaField): void {}

  onLinkClick(_event: unknown, _media: GraphicsInfoMediaField): void {}

  markForCheck(): void {
    this._changeDetectorRef.markForCheck();
  }
}
